module.exports = __webpack_public_path__ + "static/media/ice-cream.ad6e2db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/ice-cream.png
// module id = 736
// module chunks = 0